import type { GraphSnapshot, EvaluationResult } from "../domain/model";

export async function fetchGraph(): Promise<GraphSnapshot> {
  const response = await fetch("/api/graph", { headers: { Accept: "application/json" } });
  if (!response.ok) throw new Error(`Graph API failed with ${response.status}.`);
  return response.json() as Promise<GraphSnapshot>;
}

export async function evaluateNode(nodeId: string, evidenceIds: string[]): Promise<EvaluationResult> {
  const response = await fetch("/api/evaluate", {
    method: "POST",
    headers: { Accept: "application/json", "Content-Type": "application/json" },
    body: JSON.stringify({ nodeId, evidenceIds }),
  });
  if (!response.ok) throw new Error(`Evaluation API failed with ${response.status}.`);
  return response.json() as Promise<EvaluationResult>;
}
